import React from 'react';
import ctrl from 'controllers/cotacao-ctrl';
import utils from 'utils/utils';
import Row from 'components/row';
import Col from 'components/col';
import FormComboBox from 'components/form-combo-box';
import FormInput from 'components/form-input';
import Itens from './ofertar-itens';
import AvisoNotaFornecedor from 'views/cotacao/aviso-nota-fornecedor';

module.exports = React.createClass({

  handleFornecedor(value){
    ctrl.requestFornecedor(parseInt(value)).success(function(){
      ctrl.selectItem();
    });
  },

  render(){
    var content;

    if (!ctrl.data.fornecedor) {
      content = <div className="well">Por favor, escolha o fornecedor.</div>
    } else if (ctrl.dadosFornec.notaFornecedor <= 5) {
      content = <AvisoNotaFornecedor />
    } else {
      content = <Itens />
    }

    return (
      <div>
        <Row>
          <FormComboBox size="sm-12" data={ctrl.data.fornecedores} emptyItem={ctrl.data.fornecedor==-1} value={ctrl.data.fornecedor} onChange={this.handleFornecedor} label="Fornecedor"/>
        </Row>
        {content}
      </div>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/ofertar/ofertar.js
 **/